import React from "react";

import './Footer.css'

const Footer = () => {
    return (
        <div>

            <p className='footer text-white'>Mohammad Fahim Hossain © 2021</p>
        </div>
    );
};

export default Footer;